export const Services = (props) => {
  return (
    <div id='services' className='text-center'>
      <div className='container'>
        <div className='section-title'>
          <h2>Money</h2>
          <p>
            Our business model
          </p>
        </div>
        <div className='row'>
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className='col-md-4'>
                  {' '}
                  <i className={d.icon}></i>
                  <div className='service-desc'>
                    <h3>{d.name}</h3>
                    <p>{d.text}</p>
                  </div>
                </div>
              ))
            : 'loading'}
          <h4>
              Please <a href='#contact' className='page-scroll'>
                CONTACT
              </a> us if you are interested in contributing time, resources or funds!
          </h4>
        </div>
      </div>
    </div>
  )
}
